import { ERROR_CODES } from '@shinetools/errors';

const {
  BULK_BANK_TRANSFER_AMOUNT_NOT_IN_EURO,
  BULK_BANK_TRANSFER_AMOUNT_TOO_HIGH,
  BULK_BANK_TRANSFER_FILE_FORMAT_NOT_SUPPORTED,
  BULK_BANK_TRANSFER_FILE_NOT_PARSABLE,
  BULK_BANK_TRANSFER_IBAN_NOT_SEPA,
  BULK_BANK_TRANSFER_IBAN_NOT_VALID,
  BULK_BANK_TRANSFER_INSUFFICIENT_FUNDS,
  BULK_BANK_TRANSFER_LABEL_HAS_SPECIAL_CHAR,
  BULK_BANK_TRANSFER_RECIPIENT_NAME_DIFFERS,
  BULK_BANK_TRANSFER_TOO_MANY_TRANSFERS,
} = ERROR_CODES;

export const MAXIMUM_TRANSFER_WITHOUT_RECEIPT_AMOUNT = 10000;
export const MAXIMUM_BULK_TRANSFERS_COUNT = 100;

export const NON_BLOCKING_BULK_TRANSFERS_ERROR = [
  BULK_BANK_TRANSFER_RECIPIENT_NAME_DIFFERS,
];

export const GLOBAL_BULK_TRANSFERS_ERRORS = [
  BULK_BANK_TRANSFER_FILE_FORMAT_NOT_SUPPORTED,
  BULK_BANK_TRANSFER_FILE_NOT_PARSABLE,
  BULK_BANK_TRANSFER_INSUFFICIENT_FUNDS,
  BULK_BANK_TRANSFER_TOO_MANY_TRANSFERS,
];

export const INDIVIDUAL_BULK_TRANSFERS_ERRORS = [
  BULK_BANK_TRANSFER_AMOUNT_TOO_HIGH,
  BULK_BANK_TRANSFER_IBAN_NOT_VALID,
  BULK_BANK_TRANSFER_IBAN_NOT_SEPA,
  BULK_BANK_TRANSFER_AMOUNT_NOT_IN_EURO,
  BULK_BANK_TRANSFER_LABEL_HAS_SPECIAL_CHAR,
];
